import React from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import { formatTitle } from 'utils/conversions'
import Grid from './Grid'
var slugify = require('slugify')

const Container = styled.div`
	margin-bottom: 45px
`

const Header = styled.div`
	display: flex;
	justify-content: space-between;
`

const Title = styled.h3`
	font-size: 1.2rem;
    font-weight: 600;
    font-family: 'Avenir Next';
    margin-bottom: 20px;
`

const SeeMore = styled(Link)`
	font-size: .8rem;
	color: #1264a3;
`

export default ({title, companies}) => (
	<Container>
		<Header>
			<Title>{formatTitle(title)}</Title>
			<SeeMore to={`/categories/${slugify(title)}`}>See All</SeeMore>
		</Header>
		<Grid companies={companies.slice(0,6)}/>
	</Container>
)